import { AppState } from "store/rootReducer";
import { createSelector } from "reselect";

const generalErrorsState = (state: AppState) => state.general.errors;

export const getErrorInfo = createSelector(generalErrorsState, ({ hasError, message }) => ({ hasError, message }));
